import { useEffect, useRef } from "react";

// When a form swaps itself for a short confirmation, the page shrinks but the
// browser keeps its scroll position, leaving the visitor looking at the footer.
// Attach the returned ref to the confirmation: once `active` turns true it is
// scrolled into view and focused (so screen readers announce it too).
export default function useRevealWhen(active) {
  const ref = useRef(null);
  useEffect(() => {
    if (!active || !ref.current) return;
    ref.current.scrollIntoView({ behavior: "smooth", block: "center" });
    ref.current.focus({ preventScroll: true });
  }, [active]);
  return ref;
}
